import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

/** Fields of a rent contract (Mietvertrag) of a Standort. Rent is confidential: never grant to teachers. */
export enum RentContractFields {
    INSTITUTION = 'institution',
    TITLE = 'title',
    ROOMS = 'rooms',
    RESPONSIBLE = 'responsible',
    COUNTERPARTY_NAME = 'counterpartyName',
    VERSIONS = 'versions',
    DOCUMENTS = 'documents',
    NOTE = 'note',
    CHANGE_LOG = 'changeLog',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace RentContractFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<RentContractFields, Data> = {
        [RentContractFields.INSTITUTION]: {text: 'Standort', readOnly: true},
        [RentContractFields.TITLE]: {text: 'Bezeichnung'},
        [RentContractFields.ROOMS]: {text: 'Räume (leer = ganzer Standort)'},
        [RentContractFields.RESPONSIBLE]: {text: 'Vertragspartner:in (Verantwortliche:r)'},
        [RentContractFields.COUNTERPARTY_NAME]: {text: 'Vertragspartner:in (Freitext)'},
        [RentContractFields.VERSIONS]: {text: 'Versionen (Abrechnungsmodell, Preise, Gültigkeit, Pausen)'},
        [RentContractFields.DOCUMENTS]: {text: 'Dokumente'},
        [RentContractFields.NOTE]: {text: 'Notiz'},
        [RentContractFields.CHANGE_LOG]: {text: 'Änderungsverlauf', readOnly: true},
        [RentContractFields.CREATED_AT]: {text: 'Erzeugungsdatum', readOnly: true},
        [RentContractFields.UPDATED_AT]: {text: 'Aktualisiert am', readOnly: true},
    };

    export const Items = mapRecordToItems(Record);
}
